const {HTMLElement} = window


/*
 * Get the max height beteew current value or height of HTMLElement
 *
 * @param {number} currentMax Current maximum
 * @param {HTMLElement} offsetHeight Deconstruction of height of Element
 */
function getMaxHeight (currentMax, {offsetHeight}) {
  return offsetHeight > currentMax ? offsetHeight : currentMax
}


/*
 * Set at all element the height of the biggest of them
 *
 * @param {Nodelist|Array<HTMLElement>} elements
 */
function uniformizeHeight (elements) {
  const arr = Array.prototype.slice.call(elements)

  // reinit height
  arr.forEach(elmt => { elmt.style.height = 'auto' })

  // get max height after reinitialize it to auto
  const maxHeight = arr.reduce(getMaxHeight, 0)

  // apply height on each
  arr.forEach(elmt => { elmt.style.height = `${maxHeight}px` })
}


/*
 * Wait for the event was not trigger before the timer has finished
 *
 * @param {number|string} id Uniq id for identify the calling
 * @param {Function} cb Function to call when the event was finished
 * @param {number} time Time in millisecond to wait
 */
const waitForFinalEvent = (function () {
  const events = new Map()

  return function (cb, time, id) {
     if (events.has(id)) {
        // clear previous event timer
        clearTimeout(events.get(id))
     }

     // store timer by the id
     events.set(
        id,
        setTimeout(() => {
           // call the function
           cb()
           // remove timer
           events.delete(id)
        }, time)
     )
  }
})()

/*
 * Generate a random intiger between range
 *
 * @param {number} min Minimum
 * @param {number} max Maximum
 */
function rand(min = 0, max = 100) {
  return Math.floor(Math.random() * Math.floor(max - min + min))
}


/*
 * Set at all element the height of the biggest of them
 *
 * @param {Nodelist|Array<HTMLElement>} elements
 */
export function setAllToMaxHeight (elements) {
  elements = Array.prototype.slice.call(document.querySelectorAll(elements))
    .filter(elmt => elmt instanceof HTMLElement)

  // uniformize
  uniformizeHeight(elements)

  // need to define a uniq id before runing the eventlistener
  const idEvent = rand()
  // on resize recalculate
  window.addEventListener('resize', () => {
    waitForFinalEvent(() => uniformizeHeight(elements), 500, idEvent)
  })
}
